import { METRIC_NAME, SERVER_TYPE, JS_SERVER_TYPE, DEFAULT_ANTI_SPIDER } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global';
import { asyncLoadFile } from '@/utils/asyncLoadFile';

export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['csrandom'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], site_from: string, brand: 'shein' | 'romwe', channel: string }) {
    const { url, interval } = data
    window['_INCSCONF'] = {
        appName: extra.brand,
        apiUrl: `${SERVER_TYPE[extra.env][extra.server_type]}/risk/verify/identity/validation/publish/sign/rule`,
        channel: extra.channel,
        interval: interval || DEFAULT_ANTI_SPIDER.csrandom.interval
    }
    loadScript(url, extra.env, extra.server_type);
}

const loadScript = (url: string, env: string, server_type: string) => {
    const time = Date.now()
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadCsrandom' },
            value: Date.now() - time,
            message: 'csrandom load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime('csrandom', JS_SERVER_TYPE[env][server_type]);
    })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadCsrandomError' },
                value: Date.now() - time,
                message: 'csrandom load error',
                params: error
            })
        })
}